export class DateHelper {
    public static convertDotNetDateToUTCDate(input: string): Date {
        return new Date(Date.parse(input + 'Z'));
    }
}
